/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PeopleIcon = ({ width = 24, height = 24, hidden = false, title = 'People' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m15.75,2H4.25c-1.24023,0-2.25,1.00928-2.25,2.25v11.5c0,1.24072,1.00977,2.25,2.25,2.25h11.5c1.24023,0,2.25-1.00928,2.25-2.25V4.25c0-1.24072-1.00977-2.25-2.25-2.25ZM3.5,4.25c0-.41357.33691-.75.75-.75h11.5c.41309,0,.75.33643.75.75v11.5c0,.0199-.00977.03662-.01135.05615-1.53015-1.88647-3.98914-3.05615-6.4906-3.05615-2.58789,0-5.11426,1.1958-6.48804,3.04944-.00122-.01721-.01001-.03186-.01001-.04944V4.25Zm11.60938,12.25H4.87256c1.12866-1.37219,3.09216-2.25,5.12549-2.25,1.94409,0,3.85107.85571,5.11133,2.25Z"
      fill="currentColor"
    />
    <path
      d="m10.05957,11.70801c-.01953,0-.06348.00244-.05762-.00049-.5918,0-1.16797-.16748-1.66699-.48535-.49121-.31445-.8916-.75195-1.15918-1.26709-.28223-.53662-.42773-1.14453-.41895-1.75635-.02246-1.17773.56543-2.28809,1.57227-2.94678,1.02148-.64795,2.32812-.64844,3.3418-.00537.49023.31885.89062.75293,1.16211,1.25977.2832.52051.42969,1.11279.42383,1.71094.00977.5918-.13477,1.20264-.41895,1.74658-.26855.51514-.66895.95459-1.15918,1.27051-.48828.31104-1.0459.47363-1.61914.47363Zm-.04297-1.50049h.00977c.28613.01709.58984-.0752.84277-.23584.26855-.17285.49023-.41602.63867-.70117.16895-.32422.25488-.68652.24902-1.04932.00391-.36279-.08008-.70264-.24316-1.00195-.15527-.28809-.37988-.53271-.65332-.71045-.51758-.32861-1.19531-.3291-1.71875.00439-.56348.36816-.89746.99951-.88477,1.68213-.00488.38672.08105.74609.24805,1.06494.14844.28516.36816.52539.63672.69775.25781.16357.53711.21973.86621.24951h.00879Z"
      fill="currentColor"
    />
  </svg>`;
};
